<template>
  <div class="card card-custom">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">Thông tin khách hàng</h3>
      </div>
    </div>
    <div class="card-body">
      <b-row>
        <b-col md="6" class="section-row">
          <ValidationProvider
            name="Giới tính"
            rules="required"
            v-slot="{ errors }"
          >
            <b-form-group label-for="gender">
              <template #label>
                Giới tính<span style="color: red">*</span>
              </template>
              <Treeselect
                v-model="leadForm.gender"
                id="gender"
                :options="genderOptions"
                :placeholder="'Chọn giới tính'"
                :cache-options="false"
                :normalizer="normalizer"
                :disabled="mode === MODE.VIEW"
                required
                retryText="Thử lại..."
                retryTitle="Nhấp thử lại"
                searchPromptText="Nhập để tìm kiếm..."
                loadingText="Đang tải..."
                noResultsText="Không có kết quả"
                openDirection="bottom"
              />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="Danh xưng"
            rules="required"
            v-slot="{ errors }"
          >
            <b-form-group label-for="title">
              <template #label>
                Danh xưng<span style="color: red">*</span>
              </template>
              <Treeselect
                v-model="leadForm.title"
                id="title"
                :options="titleOptions"
                :multiple="false"
                :placeholder="'Chọn danh xưng'"
                :cache-options="false"
                :normalizer="normalizer"
                :disabled="mode === MODE.VIEW"
                required
                retryText="Thử lại..."
                retryTitle="Nhấp thử lại"
                searchPromptText="Nhập để tìm kiếm..."
                loadingText="Đang tải..."
                noResultsText="Không có kết quả"
                openDirection="bottom"
              />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <ValidationProvider
            name="Họ và tên"
            rules="required"
            v-slot="{ errors }"
            class="flex-grow-1"
          >
            <b-form-group
              label="Họ và tên"
              label-for="fullName"
              class="required-control"
            >
              <b-form-input
                v-model="leadForm.fullName"
                :state="errors.length > 0 ? false : null"
                id="fullName"
                class="flex-grow-1"
                :readonly="mode === MODE.VIEW"
                placeholder="Nhập họ và tên"
              />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6" class="section-row">
          <b-form-group label="Ngày sinh" label-for="birthDate" class="w-100">
            <date-picker
              v-model="leadForm.birthDate"
              id="birthDate"
              placeholder="Chọn ngày sinh"
              :config="configs.date"
              :disabled="mode === MODE.VIEW"
            >
            </date-picker>
          </b-form-group>

          <ValidationProvider
            name="Số điện thoại"
            rules="required"
            v-slot="{ errors }"
            class="w-100"
          >
            <b-form-group
              label="Số điện thoại"
              label-for="phoneNumber"
              class="required-control"
            >
              <b-form-input
                v-model="leadForm.phoneNumber"
                id="phoneNumber"
                :state="errors.length > 0 ? false : null"
                :readonly="mode === MODE.VIEW"
                placeholder="Nhập số điện thoại"
              />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </b-col>

        <b-col md="6">
          <b-form-group label="Email" label-for="email" class="flex-grow-1">
            <b-form-input
              type="email"
              v-model.trim="leadForm.email"
              id="email"
              :readonly="mode === MODE.VIEW"
              placeholder="Nhập email"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6" class="section-row">
          <b-form-group label="CCCD" class="w-100">
            <b-form-input
              v-model.trim="leadForm.citizenId"
              id="citizenId"
              :readonly="mode === MODE.VIEW"
              placeholder="Nhập số CCCD"
            />
          </b-form-group>
          <b-form-group
            label="Ngày cấp"
            label-for="citizenIdIssuedDate"
            class="w-100"
          >
            <date-picker
              v-model="leadForm.citizenIdIssuedDate"
              id="citizenIdIssuedDate"
              placeholder="Chọn ngày cấp CCCD"
              class="form-control form-control-sm w-100"
              :config="configs.date"
              :disabled="mode === MODE.VIEW"
            >
            </date-picker>
          </b-form-group>
        </b-col>

        <b-col md="6" class="section-row">
          <b-form-group label="Tên công ty" class="w-100">
            <b-form-input
              v-model.trim="leadForm.companyName"
              id="companyName"
              :readonly="mode === MODE.VIEW"
              placeholder="Nhập tên công ty"
            />
          </b-form-group>
          <b-form-group label="Mã số thuế" class="w-100">
            <b-form-input
              v-model.trim="leadForm.taxCode"
              id="taxCode"
              :readonly="mode === MODE.VIEW"
              placeholder="Nhập mã số thuế"
              lazy
            />
          </b-form-group>
          <b-form-group
            label="ID App Dcore"
            label-for="appDcoreId"
            class="w-100"
          >
            <b-form-input
              v-model.trim="leadForm.appDcoreId"
              id="appDcoreId"
              :readonly="mode === MODE.VIEW"
              placeholder="Nhập ID App Decore"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Status and Customer Group Row -->
      <b-row class="mt-3">
        <b-col md="6" class="section-row">
          <ValidationProvider
            name="Tình trạng"
            rules="required"
            v-slot="{ errors }"
          >
            <b-form-group label-for="status">
              <template #label>
                Tình trạng<span style="color: red">*</span>
              </template>
              <Treeselect
                v-model="leadForm.status"
                id="status"
                :options="statusOptions"
                :multiple="false"
                :placeholder="'Chọn trạng thái'"
                :cache-options="false"
                :normalizer="normalizer"
                :disabled="mode === MODE.VIEW"
                required
                retryText="Thử lại..."
                retryTitle="Nhấp thử lại"
                searchPromptText="Nhập để tìm kiếm..."
                loadingText="Đang tải..."
                noResultsText="Không có kết quả"
                openDirection="bottom"
              />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <b-form-group label="Nhóm khách hàng" label-for="customerGroup">
            <Treeselect
              v-model="leadForm.customerGroup"
              id="customerGroup"
              :options="customerGroupOptions"
              :multiple="false"
              :placeholder="'Chọn nhóm khách hàng'"
              :cache-options="false"
              :normalizer="normalizer"
              :disabled="mode === MODE.VIEW"
              retryText="Thử lại..."
              retryTitle="Nhấp thử lại"
              searchPromptText="Nhập để tìm kiếm..."
              loadingText="Đang tải..."
              noResultsText="Không có kết quả"
              openDirection="bottom"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="section-row">
          <b-form-group
            label="Ngày chuyển đổi"
            label-for="conversionDate"
            class="w-100"
          >
            <date-picker
              v-model="leadForm.conversionDate"
              id="conversionDate"
              placeholder="Chọn ngày chuyển đổi"
              :config="configs.date"
              :disabled="mode === MODE.VIEW || !isConversionDateEnabled"
            >
            </date-picker>
          </b-form-group>
          <b-form-group label="Đánh giá" label-for="evaluation" class="w-100">
            <Treeselect
              v-model="leadForm.evaluation"
              id="evaluation"
              :options="evaluationOptions"
              :multiple="false"
              :placeholder="'Chọn đánh giá'"
              :cache-options="false"
              :normalizer="normalizer"
              :disabled="mode === MODE.VIEW"
              retryText="Thử lại..."
              retryTitle="Nhấp thử lại"
              searchPromptText="Nhập để tìm kiếm..."
              loadingText="Đang tải..."
              noResultsText="Không có kết quả"
              openDirection="bottom"
              @input="updateField('evaluation', $event)"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <ValidationProvider name="Nguồn" rules="required" v-slot="{ errors }">
            <b-form-group label="Nguồn" label-for="source">
              <template #label>
                Nguồn<span style="color: red">*</span>
              </template>
              <Treeselect
                v-model="leadForm.source"
                id="source"
                :options="sourceOptions"
                :multiple="false"
                :placeholder="'Chọn nguồn'"
                :cache-options="false"
                :normalizer="normalizer"
                :disabled="mode === MODE.VIEW"
                required
                retryText="Thử lại..."
                retryTitle="Nhấp thử lại"
                searchPromptText="Nhập để tìm kiếm..."
                loadingText="Đang tải..."
                noResultsText="Không có kết quả"
                openDirection="bottom"
                @input="updateField('source', $event)"
              />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <b-form-group label="Địa chỉ" label-for="address">
            <b-textarea
              v-model.trim="leadForm.address"
              id="address"
              rows="3"
              :readonly="mode === MODE.VIEW"
              placeholder="Nhập địa chỉ"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ValidationProvider } from 'vee-validate';
import { LeadModel } from '@/core/models/Lead.model';

import { DP_CONFIG } from '@/utils/date';

import * as ENUM from '@/utils/enum';

export default {
  name: 'CustomerInformation',
  components: {
    ValidationProvider,
    Treeselect,
  },
  data() {
    return {
      MODE: ENUM.MODE,
      // Configs
      configs: DP_CONFIG,
    };
  },
  props: {
    leadForm: {
      type: [Object, LeadModel],
      required: true,
    },
    mode: {
      type: String,
      required: false,
      default: ENUM.MODE.VIEW,
    },
    titleOptions: {
      type: Array,
      required: true,
    },
    genderOptions: {
      type: Array,
      required: true,
    },
    sourceOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    customerGroupOptions: {
      type: Array,
      required: true,
    },
    evaluationOptions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isConversionDateEnabled() {
      return (
        this.leadForm.evaluation === ENUM.LEAD_EVALUATION.CONVERTED ||
        this.leadForm.status === ENUM.LEAD_STATUS.POTENTIAL ||
        this.leadForm.status === ENUM.LEAD_STATUS.PURCHASED
      );
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update-field', { field, value });
    },
    normalizer(node) {
      return {
        id: node.value,
        label: node.text,
      };
    },
  },
};
</script>

<style scoped>
.required-control label::after {
  content: '*';
  color: red;
}
.section-row {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>
